<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-slide-x-transition mode="out-in">
        <v-flex
          xs12
          sm4
          pa-3
          :key="1"
          md4
          v-if="!flags.editDoor"
          dooScroll
          scrollDesign
          class="expandableContainer"
        >
          <v-slide-y-transition class="two-line subheader" group tag="v-list">
            <v-subheader key="subheader" inset>
              {{ markers.length }}
              {{ $t('configuration.location_settings.doors') }}
            </v-subheader>
            <v-list-tile
              v-for="(item, index) in markers"
              :key="item.doorName"
              avatar
              ripple
              class="pa-2 mb-3 elevation-1 grey lighten-5"
              style="border-radius: 5px"
              @click="focusedDoor($event, item, index, false)"
            >
              <v-list-tile-avatar>
                <img
                  :src="
                    require('@/assets/panel/toolbar/SKLB-Cerrar Sesion.png')
                  "
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.doorName }}</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ item.street }}
                  <br />
                  {{ item.type | filterTypeDoor }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      v-if="permits['UPDATE_SETTINGS']"
                      icon
                      ripple
                      @click="focusedDoor($event, item, null, true)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{ $t('configuration.location_settings.edit_door') }}
                  </span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      v-if="permits['DELETE_DOORS']"
                      icon
                      ripple
                      @click="confirmDesition(item, $event)"
                    >
                      <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{ $t('configuration.location_settings.delete_door') }}
                  </span>
                </v-tooltip>
              </v-list-tile-action>
            </v-list-tile>
          </v-slide-y-transition>
        </v-flex>
        <v-flex
          xs12
          sm4
          pa-3
          :key="2"
          v-if="flags.editDoor"
          md4
          class="expandableContainer"
        >
          <v-form v-model="valid" lazy-validation @submit.prevent="processForm">
            <v-container>
              <v-layout row wrap>
                <p>
                  {{ $t('configuration.location_settings.door_information') }}
                </p>
                <v-flex xs12>
                  <v-text-field
                    v-model="doorForm.doorName"
                    @blur="$v.doorForm.doorName.$touch()"
                    :label="$t('configuration.location_settings.name')"
                    required
                    :error-messages="processErrorName"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="doorForm.street"
                    @blur="$v.doorForm.street.$touch()"
                    :label="
                      $t('configuration.location_settings.reference_street')
                    "
                    required
                    :error-messages="processErrorStreet"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    :items="typeDoors"
                    item-text="text"
                    item-value="value"
                    :label="$t('configuration.location_settings.door_type')"
                    v-model="doorForm.type"
                    @blur="$v.doorForm.type.$touch()"
                    outline
                    :error-messages="processErrorType"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    :label="
                      $t('configuration.location_settings.radial_distance')
                    "
                    type="number"
                    v-model="doorForm.distanceSetting"
                    :error-messages="processErrordistanceSetting"
                    :suffix="$t('configuration.meters')"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  sm10
                  :style="{
                    alignSelf: 'center',
                    textAlign: 'left',
                  }"
                >
                  <v-label style="float: left">
                    {{
                      $t('configuration.location_settings.select_door_color')
                    }}
                  </v-label>
                </v-flex>
                <v-flex xs12 sm2 :style="{ alignSelf: 'center' }">
                  <v-btn
                    dark
                    fab
                    small
                    class="helpButton"
                    color="gradiente"
                    @click="help('DOORS_COLORS')"
                  >
                    <b>?</b>
                  </v-btn>
                </v-flex>
                <flex sx12 class="px-1">
                  <v-swatches
                    v-model="doorForm.color"
                    row-length="5"
                    :swatches="colors"
                    popover-x="right"
                  ></v-swatches>
                </flex>
                <v-flex xs12>
                  <v-btn
                    :disabled="working.wDoor"
                    @click="cancelDoor"
                    large
                    round
                  >
                    {{ $t('configuration.cancel') }}
                  </v-btn>
                  <v-btn
                    :disabled="working.wDoor"
                    class="gradiente white--text"
                    large
                    round
                    type="submit"
                  >
                    {{ $t('configuration.save') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-slide-x-transition>
      <v-flex xs12 sm8 md8 pa-0>
        <GmapMap
          ref="mapSettings"
          :center="{
            lat:
              mapCenterFocus.lat !== null
                ? mapCenterFocus.lat
                : getBranch.latitude != null
                ? getBranch.latitude
                : 19.702559,
            lng:
              mapCenterFocus.lng !== null
                ? mapCenterFocus.lng
                : getBranch.longitude != null
                ? getBranch.longitude
                : -101.192341,
          }"
          :zoom="getBranch.zoom != null ? getBranch.zoom : 20"
          style="height: 500px; margin-top: 3px"
          :options="mapConfig"
          @zoom_changed="zoomChanged"
          @center_changed="centerChanged"
        >
          <GmapMarker
            :position="{
              lat:
                branch.markLatitude != null ? branch.markLatitude : 19.702559,
              lng:
                branch.markLongitude != null
                  ? branch.markLongitude
                  : -101.192341,
            }"
            :draggable="
              (permits['UPDATE_SETTINGS'] ? true : false) &&
              !flags.editDoor &&
              !addDoor
            "
            :icon="google && markerBranchIcon"
            @dragend="branchLocation"
          >
            <GmapInfoWindow
              :position="{
                lat:
                  branch.markLatitude != null ? branch.markLatitude : 19.702559,
                lng:
                  branch.markLongitude != null
                    ? branch.markLongitude
                    : -101.192341,
              }"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <p>{{ branch.address }}</p>
              <p>{{ branch.timezone }}</p>
              <v-btn
                round
                color="gradiente"
                @click="changeDoorsPosition"
                small
                dark
                >Cambiar puertas
              </v-btn>
            </GmapInfoWindow>
          </GmapMarker>

          <GmapMarker
            :key="m.id"
            v-for="(m, index) in markers"
            :position="{ lat: m.latitude, lng: m.longitude }"
            :draggable="
              (permits['UPDATE_SETTINGS'] ? true : false) &&
              (!flags.editDoor || m.id == doorForm.id) &&
              !addDoor
            "
            :title="m.doorName"
            :label="m.doorName"
            :icon="markerDoorIcon"
            @dragend="markerLocation($event, m)"
          />
          <GmapMarker
            :animation="2"
            :key="m.id"
            v-for="(m, index) in newMarkers"
            :position="{ lat: m.latitude, lng: m.longitude }"
            :clickable="true"
            :draggable="true"
            :title="m.doorName"
            :label="m.doorName"
            :icon="markerDoorIcon"
            @dragend="newMarkerLocation($event, m)"
          />
          <GmapCircle
            v-for="(pin, index) in markers"
            :key="pin.distanceSetting"
            :center="{ lat: pin.latitude, lng: pin.longitude }"
            :radius="
              parseInt(pin.distanceSetting) >= 5000
                ? 0
                : parseInt(pin.distanceSetting)
            "
            :visible="true"
            :options="{
              strokeColor: '#C80909',
              strokeOpacity: pin.isFocused || pin.id === doorForm.id ? 1 : 0,
              strokeWeight: 1,
              fillColor: '#EA5D5F',
              fillOpacity: 0.3,
            }"
          ></GmapCircle>
          <v-toolbar
            dense
            color="transparent"
            floating
            id="toolbarConfiguration"
            class="titleSearch elevation-0"
          >
            <v-text-field
              class="mx-3 mt-4"
              @keyup.enter="searchName"
              :label="$t('configuration.location_settings.search')"
              prepend-inner-icon="search"
              clearable
              solo
              v-model="search"
            ></v-text-field>
          </v-toolbar>
        </GmapMap>
      </v-flex>
      <v-flex xs12 sm8 md8 offset-xs12 offset-sm4>
        <label>
          {{ $t('configuration.location_settings.school_address') }}
          {{ branch.address }} |
          {{ $t('configuration.location_settings.time_zone') }}
          {{ branch.timezone }} | Latitud: {{ branch.markLatitude }} | Longitud:
          {{ branch.markLongitude }} | Zoom:
          {{ branch.zoom }}
        </label>
        <br />
        <label class="red--text">
          {{ $t('configuration.location_settings.change_school_location') }}
        </label>
      </v-flex>
    </v-layout>
    <loading v-model="working.wDoor" text="Actualizando..."></loading>
    <success v-model="toast.success" text="Actualización Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <confirmNewUi
      :show="showConfirmRadius"
      title="Detectamos que seleccionaste una distancia mayor a 500m, para un mejor resultado en las solicitudes de alumnos, te sugerimos seleccionar un radio menor."
      description="¿Deseas guardar la distancia radial establecida?"
      :cancel-text="$t('generic.cancel')"
      :ok-text="$t('generic.save')"
      @change="onChangeConfirm"
    ></confirmNewUi>
    <confirm
      v-model="modals.desitionDelete"
      v-on:desition="deleteDoorDesition"
      :title="$t('configuration.location_settings.delete_door')"
      :description="
        $t('configuration.location_settings.delete_door_description')
      "
    ></confirm>
    <help
      v-model="helpDialog.flag"
      :title="helpDialog.title"
      :description="helpDialog.description"
    ></help>
  </v-flex>
</template>

<script>
import { mapSettings } from '@/Catalogs/mapSettings'
import { gmapApi } from 'vue2-google-maps'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { funciones } from '../../../Mixins/Funciones'
import confirm from '../../Dialogs/Confirm.vue'
import error from '../../Dialogs/Error.vue'
import help from '../../Dialogs/Help'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import confirmNewUi from '../../Dialogs/confirm_new_ui.vue'

import VSwatches from 'vue-swatches'

export default {
  components: {
    loading,
    success,
    error,
    confirm,
    confirmNewUi,
    VSwatches,
    help,
  },
  mixins: [funciones],
  validations: {
    doorForm: {
      doorName: { required },
      street: { required },
      type: { required },
      distanceSetting: { required },
    },
  },
  props: ['addDoor', 'permits', 'downloadDoors'],
  data: () => ({
    showConfirmRadius: false,
    mapCenterFocus: { lat: null, lng: null, indexFocus: null },
    helpDialog: { title: '', description: '', flag: false },
    colors: [
      '#FBC02D',
      '#F57F17',
      '#F4511E',
      '#D84315',
      '#BCAAA4',
      '#795548',
      '#5D4037',
      '#26C6DA',
      '#0097A7',
      '#B39DDB',
      '#5E35B1',
      '#6200EA',
      '#6A1B9A',
      '#E040FB',
      '#607D8B',
      '#1D3A9A',
      '#222E87',
      '#22307B',
      '#D5539D',
      '',
    ],
    infoWinOpen: false,
    valid: false,
    buttonFab: {
      fab: false,
    },
    search: '',
    typeDoors: [
      {
        text: 'Mixto',
        value: 'M',
      },
      {
        text: 'Caminando',
        value: 'W',
      },
      {
        text: 'Carro',
        value: 'C',
      },
    ],
    branch: {},
    map: null,
    markers: [],
    newMarkers: [],
    flags: {
      editDoor: false,
      desitionDeleteDoor: false,
      searched: false,
    },
    selected: {
      doorForm: {},
      doorDelete: {},
    },
    doorForm: {
      id: null,
      doorName: '',
      street: '',
      type: '',
      longitude: '',
      latitude: '',
      distanceSetting: '',
      color: '',
    },
    working: {
      wDoor: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      desitionDelete: false,
    },
  }),
  watch: {
    getBranch() {
      if (this.getBranch.latitude != null && this.getBranch.longitude != null) {
        this.$emit('location', {
          latitude: this.getBranch.latitude,
          longitude: this.getBranch.longitude,
        })
        this.$emit('branchLocation', {
          latitude: this.getBranch.markLatitude,
          longitude: this.getBranch.markLongitude,
          address: this.getBranch.address,
        })
        this.branch = this.getBranch
        this.getStoreDoors()
      }
    },
    downloadDoors() {
      if (this.downloadDoors) {
        var array = []
        for (let m of this.markers) {
          var marker = m
          marker.doorType = this.$options.filters.filterTypeDoor(m.type)
          array.push(marker)
        }
        this.download('puertas', array)
        this.$emit('downloaded')
      }
    },
    getDoors() {
      this.markers = this.getDoors
    },
    addDoor() {
      if (this.addDoor) {
        this.flags.editDoor = true
        var nDoor = {
          doorName: '',
          type: '',
          street: '',
          longitude: this.getBranch.longitude,
          latitude: this.getBranch.latitude,
          distanceSetting: '',
          color: '',
        }
        this.newMarkers.push(nDoor)
        this.doorForm = nDoor
      }
    },
    permits() {
      this.$forceUpdate()
    },
  },
  filters: {
    filterTypeDoor(value) {
      switch (value) {
        case 'M':
          return 'Mixto'
        case 'C':
          return 'Carro'
        case 'W':
          return 'Caminando'
      }
    },
  },
  mounted() {
    if (this.getBranch.id != null) {
      this.getStoreDoors()
      this.branch = this.getBranch
    }
    var v = this
    this.$refs.mapSettings.$mapPromise.then((map) => {
      v.map = map
      map.setZoom(v.branch.zoom != null ? v.branch.zoom : 17)
      var input = document.getElementById('toolbarConfiguration')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(input)
    })
  },
  methods: {
    focusedDoor(event, door = {}, index = null, isEdit = false) {
      event.stopPropagation()

      if (isEdit === true) {
        this.selectDoor(door)
      }

      if (
        this.mapCenterFocus.indexFocus !== null &&
        this.markers[this.mapCenterFocus.indexFocus].id === door.id &&
        isEdit === false
      ) {
        this.markers[this.mapCenterFocus.indexFocus].isFocused = false
        this.mapCenterFocus = {
          indexFocus: null,
          lat: null,
          lng: null,
        }
        return
      }

      if (this.mapCenterFocus.indexFocus !== null) {
        this.markers[this.mapCenterFocus.indexFocus].isFocused = false
      }
      if (index !== null) {
        this.markers[index].isFocused = true
      }

      this.mapCenterFocus = {
        lat: door.latitude,
        lng: door.longitude,
        indexFocus: index,
      }
    },
    help(type) {
      switch (type) {
        case 'DOORS_COLORS':
          this.helpDialog.title = this.$t(
            'configuration.location_settings.help.title'
          )
          this.helpDialog.description = this.$t(
            'configuration.location_settings.help.description'
          )
          this.helpDialog.flag = true
          break
      }
    },
    searchName() {
      this.flags.searched = true
      var v = this
      var request = {
        query: this.search,
        fields: ['name', 'geometry', 'formatted_address'],
      }
      var service = new google.maps.places.PlacesService(this.map)

      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var position = new google.maps.LatLng(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng()
          )
          v.branch.markLongitude = results[0].geometry.location.lng()
          v.branch.markLatitude = results[0].geometry.location.lat()
          v.branch.address = results[0].formatted_address
          v.$emit('branchLocation', {
            latitude: v.branch.markLatitude,
            longitude: v.branch.markLongitude,
            address: v.branch.address,
          })
          v.$store
            .dispatch('timeZoneAPI', {
              latitude: v.branch.markLatitude,
              longitude: v.branch.markLongitude,
            })
            .then((response) => {
              if (response.data.status == 'OK') {
                v.branch.timezone = response.data.timeZoneId
                v.$emit('timeZone', response.data.timeZoneId)
              }
            })
            .catch((error) => {
              console.log(error)
            })
          v.map.setCenter(position)
          v.map.setZoom(18)
          v.branch.zoom = 18
          v.infoWinOpen = true
        } else {
        }
      })
    },
    getStoreDoors() {
      this.$store.dispatch('doors/getDoors')
      this.markers = this.getDoors
    },
    selectDoor(door) {
      this.selected.doorForm = door
      this.doorForm = door
      this.flags.editDoor = true
    },
    confirmDesition(door, event) {
      event.stopPropagation()
      this.selected.deleteDoor = door
      this.modals.desitionDelete = true
    },
    cancelDoor() {
      this.showConfirmRadius = false
      this.selected.doorForm = {}
      this.doorForm = {
        doorName: '',
        street: '',
        type: '',
        longitude: '',
        latitude: '',
        color: '',
      }
      this.$v.doorForm.$reset()
      this.flags.editDoor = false
      if (this.addDoor) {
        this.newMarkers = []
        this.$emit('cancel')
      }
    },
    markerLocation(event, marker) {
      this.selectDoor(marker)
      this.doorForm.latitude = event.latLng.lat()
      this.doorForm.longitude = event.latLng.lng()
    },
    newMarkerLocation(event, marker) {
      this.doorForm.latitude = event.latLng.lat()
      this.doorForm.longitude = event.latLng.lng()
    },
    _addUpdateDoor() {
      if (this.addDoor) {
        this.createDoor()
      } else {
        this.updateDoor()
      }
    },
    onChangeConfirm(e) {
      this.showConfirmRadius = false
      if (e === false) {
        this.showConfirmRadius = false
        return
      }
      this._addUpdateDoor()
    },
    processForm() {
      this.$v.doorForm.$touch()
      if (!this.$v.doorForm.$invalid) {
        if (this.doorForm.distanceSetting <= 500) {
          this.showConfirmRadius = false
          this._addUpdateDoor()
          return
        }

        this.showConfirmRadius = true
      }
    },
    createDoor() {
      this.working.wDoor = true
      var doors = {
        entity: [this.doorForm],
      }
      var json = JSON.stringify(doors) // aqui tienes la lista de objetos en Json
      var obj = JSON.parse(json)
      this.$store
        .dispatch('doors/createDoor', obj)
        .then((response) => {
          this.flags.editDoor = false
          this.working.wDoor = false
          this.toast.success = true
          this.newMarkers = []
          this.$v.doorForm.$reset()
          this.$emit('added')
        })
        .catch((error) => {
          this.working.wDoor = false
          this.toast.failed = true
        })
    },
    updateDoor() {
      this.working.wDoor = true
      var doors = {
        entity: [this.doorForm],
      }
      var json = JSON.stringify(doors) // aqui tienes la lista de objetos en Json
      var obj = JSON.parse(json)
      this.$store
        .dispatch('doors/updateDoor', obj)
        .then((response) => {
          this.flags.editDoor = false
          this.working.wDoor = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wDoor = false
          this.toast.failed = true
        })
    },
    deleteDoorDesition(event) {
      if (event) {
        this.deleteDoor()
        this.modals.desitionDelete = false
      }
    },
    deleteDoor() {
      this.working.wDoor = true
      this.$store
        .dispatch('doors/toggleDoor', this.selected.deleteDoor.id)
        .then((response) => {
          this.working.wDoor = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wDoor = false
          this.toast.failed = true
        })
    },
    branchLocation(event) {
      if (this.flags.searched) {
        this.infoWinOpen = true
      }
      var geocoder = new google.maps.Geocoder()
      var address
      var v = this
      var latlng = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      }
      geocoder.geocode(
        {
          location: latlng,
        },
        function (results, status) {
          if (status == 'OK') {
            v.$emit('branchLocation', {
              latitude: event.latLng.lat(),
              longitude: event.latLng.lng(),
              address: results[0].formatted_address,
            })
            v.branch.markLatitude = event.latLng.lat()
            v.branch.markLongitude = event.latLng.lng()
            v.branch.address = results[0].formatted_address
          } else {
            alert('no se encontro nada')
          }
        }
      )
      this.$store
        .dispatch('timeZoneAPI', {
          latitude: event.latLng.lat(),
          longitude: event.latLng.lng(),
        })
        .then((response) => {
          if (response.data.status == 'OK') {
            v.branch.timezone = response.data.timeZoneId
            v.$emit('timeZone', v.branch.timezone)
          }
        })
    },
    zoomChanged(event) {
      this.$emit('zoom', event)
      this.branch.zoom = event
    },
    centerChanged(event) {
      this.$emit('location', {
        latitude: event.lat(),
        longitude: event.lng(),
      })
    },
    changeDoorsPosition() {
      var index = 0.0001
      for (let m of this.markers) {
        m.latitude = this.branch.markLatitude + index
        m.longitude = this.branch.markLongitude + index
        index += 0.0001
      }
      this.infoWinOpen = false
      this.flags.searched = false
    },
  },
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings,
      }
    },
    markerDoorIcon() {
      return {
        url: require('@/assets/mapIcons/if_map-marker_3688470.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },
    markerBranchIcon() {
      return {
        url: require('@/assets/mapIcons/if_graduation-cap_3688484.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },
    processErrorName() {
      const errors = []
      if (!this.$v.doorForm.doorName.$dirty) return errors
      !this.$v.doorForm.doorName.required &&
        errors.push('El nombre de la puerta es requerido')
      return errors
    },
    processErrorStreet() {
      const errors = []
      if (!this.$v.doorForm.street.$dirty) return errors
      !this.$v.doorForm.street.required &&
        errors.push('La calle aledaña de la puerta es requerida')
      return errors
    },
    processErrorType() {
      const errors = []
      if (!this.$v.doorForm.type.$dirty) return errors
      !this.$v.doorForm.type.required &&
        errors.push('El tipo de puerta es requerido')
      return errors
    },
    processErrordistanceSetting() {
      const errors = []
      if (!this.$v.doorForm.distanceSetting.$dirty) return errors
      !this.$v.doorForm.distanceSetting.required &&
        errors.push('La configuración de distancia es requerida')
      return errors
    },

    //Mappers
    ...mapGetters(['getBranch', 'getDoors']),
  },
}
</script>

<style src="vue-swatches/dist/vue-swatches.css"></style>
<style scoped>
::v-deep .v-list__tile--avatar {
  min-height: 60px;
}

.dooScroll {
  max-height: 500px;
  overflow-y: auto;
}
</style>
